/**
 * Site Settings — Global configuration
 * Future: fetched from Supabase `site_settings` table
 */

const siteSettings = {
  logo: {
    text: "Sublime Résine",
    href: "/",
  },
  seo: {
    siteName: "Sublime Résine",
    baseUrl: "https://sublimeresine.ca",
    defaultDescription:
      "Créations artisanales de bijoux en résine personnalisés pour immortaliser vos compagnons à quatre pattes. Fait main au Québec.",
    locale: "fr_CA",
    lang: "fr",
  },
  supplements: [
    { id: "sup_photo", label: "Photo", price: "+5 $", icon: "camera", description: "Intégrer la photo de votre animal dans le bijou", isActive: true, sortOrder: 1 },
    { id: "sup_poils", label: "Poils", price: "+10 $", icon: "dog", description: "Incorporer les poils de votre compagnon dans la résine", isActive: true, sortOrder: 2 },
    { id: "sup_livraison", label: "Livraison Poste Canada", price: "+5 $", icon: "truck", description: "Partout au Canada, emballage soigné", isActive: true, sortOrder: 3 },
  ],
  personalization: {
    message:
      "Toutes les créations sont personnalisables selon vos envies : couleurs, brillants, éléments intégrés et détails du design.",
  },
  messenger: {
    url: "https://m.me/61583444900823",
    isActive: true,
  },
  jsonLd: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Sublime Résine",
    description:
      "Créations artisanales de bijoux en résine personnalisés pour immortaliser vos compagnons à quatre pattes. Fait main au Québec.",
    url: "https://sublimeresine.ca",
    address: { "@type": "PostalAddress", addressRegion: "QC", addressCountry: "CA" },
    priceRange: "5$ - 30$",
  },
};

export default siteSettings;
